/*
 * Wellness USA — State Fair QR page
 * Design: Cedar & Ember (mockup option 2a).
 * Content (categories/docs) is the real fair copy; swap or extend
 * these arrays as content is finalized. Screen switching, search,
 * and favorites are all fully wired.
 */
(function(){
  var CATEGORIES = [
    { id:'products',  label:'Products',  emoji:'🛍️', description:'Featured at this state fair',   accent:'#8A5A2B', kind:'products' },
    { id:'specials',  label:'Specials',  emoji:'✨', description:"Exclusive wellness promotions", accent:'#4E9A6B' }
  ];

  // Temporary placeholder roster — swap for the real featured-product feed
  // (and real photos/PDFs) once the fair's product list is finalized.
  var PRODUCT_NAMES = [
    'RedFit™ Room','RedFit™ iGym','SaunaWellness Pro10','ClubStrong Red Light Infrared Sauna',
    'RedFit™ Recovvry™ PEMF Energy Belt','Cocoon Dry Pod','Cocoon Wet Pod',
    'RedFuzion™ LED Face Mask','RedFuzion Pod','Facial Equipment Bundle','Mats & Accessories'
  ];
  var PRODUCTS = PRODUCT_NAMES.map(function(name, i){
    return {
      id:'prod'+(i+1),
      name:name,
      pdfs:[
        { label:'Installation Manual', meta:'PDF · placeholder' },
        { label:'Safety Protocol', meta:'PDF · placeholder' },
        { label:'Warranty & Care Guide', meta:'PDF · placeholder' }
      ]
    };
  });

  var DOCS = [
    { id:'sp1', category:'specials', title:'Members-Only Sauna Ritual', readTime:'2 min read', updated:'Jul 2026', imageLabel:'photo: infrared cabin interior',
      intro:"Join our wellness circle and enjoy 20% off your first infrared sauna session, plus a complimentary aromatherapy add-on.",
      sections:[
        { heading:"What's included", body:'A full 45-minute infrared session, guided breathing intro, and a eucalyptus steam finish.' },
        { heading:'How to redeem', body:'Show this screen at check-in and mention code FAIR26. Valid through the end of the fair.' }
      ]},
    { id:'sp2', category:'specials', title:'Buy One, Gift One', readTime:'1 min read', updated:'Jul 2026', imageLabel:'photo: gift box with sauna oils',
      intro:'Share the warmth this season — every home sauna purchased includes a gift session voucher for a friend or family member.',
      sections:[ { heading:'Terms', body:'Applies to full-size home sauna units purchased at the fair. Vouchers expire in 12 months.' } ]},
    { id:'sp3', category:'specials', title:'Fair-Exclusive Aromatherapy', readTime:'1 min read', updated:'Jul 2026', imageLabel:'photo: essential oil bottles',
      intro:'Every session booked this week includes a free aromatherapy oil pairing, curated by our wellness team.',
      sections:[ { heading:'Available blends', body:'Choose from three seasonal blends crafted for relaxation, focus, or recovery.', items:['Cedar & Clary Sage — deep relaxation','Eucalyptus & Mint — clarity and focus','Sandalwood & Vetiver — recovery and calm'] } ]},
    { id:'sp4', category:'specials', title:'Early Bird Booking', readTime:'2 min read', updated:'Jun 2026', imageLabel:'photo: sauna at golden hour',
      intro:'Reserve your home sauna before Labor Day and lock in fair pricing with priority installation scheduling.',
      sections:[ { heading:'Why book early', body:'Installation slots fill quickly after the fair. Early reservations receive first access to our fall calendar.' } ]}
  ];

  function init(root){
    var state = {
      view:'home',
      activeCategory:null,
      activeDoc:null,
      activeProduct:null,
      favorites:{},
      favOnlyByCat:{},
      searchByCat:{}
    };

    var els = {
      screens: root.querySelectorAll('.screen'),
      navButtons: root.querySelectorAll('[data-nav]'),
      catList: root.querySelector('#cat-list'),
      docList: root.querySelector('#doc-list'),
      listCatTitle: root.querySelector('#list-cat-title'),
      listCatDesc: root.querySelector('#list-cat-desc'),
      favToggle: root.querySelector('#fav-toggle'),
      searchInput: root.querySelector('#search-input'),
      docBody: root.querySelector('#doc-body'),
      docFavToggle: root.querySelector('#doc-fav-toggle'),
      productBody: root.querySelector('#product-body'),
      devnavButtons: root.querySelectorAll('.devnav [data-nav]')
    };

    function catById(id){ for (var i=0;i<CATEGORIES.length;i++) if (CATEGORIES[i].id===id) return CATEGORIES[i]; return null; }
    function docById(id){ for (var i=0;i<DOCS.length;i++) if (DOCS[i].id===id) return DOCS[i]; return null; }
    function productById(id){ for (var i=0;i<PRODUCTS.length;i++) if (PRODUCTS[i].id===id) return PRODUCTS[i]; return null; }
    function countFor(cat){
      if (cat.kind === 'products') return PRODUCTS.length;
      return DOCS.filter(function(d){ return d.category===cat.id; }).length;
    }

    function setView(view){
      state.view = view;
      els.screens.forEach(function(s){ s.classList.toggle('active', s.dataset.screen===view); });
      els.devnavButtons.forEach(function(b){ b.classList.toggle('active', b.dataset.nav===view); });
      if (view==='home') renderHome();
      if (view==='list') renderList();
      if (view==='doc') renderDoc();
      if (view==='product') renderProduct();
    }

    function renderHome(){
      els.catList.innerHTML = '';
      CATEGORIES.forEach(function(cat){
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cat-card';
        btn.innerHTML =
          '<span class="cat-icon" style="color:'+cat.accent+'">'+cat.emoji+'</span>' +
          '<span class="cat-main">' +
            '<span class="cat-title-row"><span class="cat-title">'+cat.label+'</span>' +
            '<span class="cat-count">'+countFor(cat)+' items</span></span>' +
            '<span class="cat-desc">'+cat.description+'</span>' +
          '</span>' +
          '<span class="cat-chevron">›</span>';
        btn.addEventListener('click', function(){
          state.activeCategory = cat.id;
          setView('list');
        });
        els.catList.appendChild(btn);
      });
    }

    function renderList(){
      var cat = catById(state.activeCategory) || CATEGORIES[0];
      state.activeCategory = cat.id;
      els.listCatTitle.textContent = cat.label;
      els.listCatDesc.textContent = cat.description;

      var isProducts = cat.kind === 'products';
      els.favToggle.style.display = isProducts ? 'none' : '';
      var favOnly = !isProducts && !!state.favOnlyByCat[cat.id];
      els.favToggle.classList.toggle('on', favOnly);
      els.searchInput.placeholder = isProducts ? 'Search products' : 'Search this category';
      els.searchInput.value = state.searchByCat[cat.id] || '';

      els.docList.classList.toggle('product-mode', isProducts);
      if (isProducts) renderProductGrid(cat); else renderDocRows();
    }

    function renderProductGrid(cat){
      var query = (state.searchByCat[cat.id] || '').toLowerCase();
      var products = PRODUCTS.filter(function(p){ return p.name.toLowerCase().indexOf(query) !== -1; });

      els.docList.innerHTML = '';
      if (products.length === 0){
        var empty = document.createElement('div');
        empty.className = 'empty-state';
        empty.textContent = 'No matches found.';
        els.docList.appendChild(empty);
        return;
      }
      products.forEach(function(product){
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'product-card';
        card.innerHTML =
          '<span class="product-thumb"><span aria-hidden="true">🖼️</span></span>' +
          '<span class="product-name">'+product.name+'</span>';
        card.addEventListener('click', function(){
          state.activeProduct = product.id;
          setView('product');
        });
        els.docList.appendChild(card);
      });
    }

    function renderDocRows(){
      var cat = catById(state.activeCategory);
      var query = (state.searchByCat[cat.id] || '').toLowerCase();
      var favOnly = !!state.favOnlyByCat[cat.id];
      var docs = DOCS.filter(function(d){ return d.category===cat.id; })
                     .filter(function(d){ return d.title.toLowerCase().indexOf(query) !== -1; })
                     .filter(function(d){ return !favOnly || state.favorites[d.id]; });

      els.docList.innerHTML = '';
      if (docs.length === 0){
        var empty = document.createElement('div');
        empty.className = 'empty-state';
        empty.textContent = 'No matches found.';
        els.docList.appendChild(empty);
        return;
      }
      docs.forEach(function(doc){
        var row = document.createElement('div');
        row.className = 'doc-row';
        var isFav = !!state.favorites[doc.id];
        row.innerHTML =
          '<span class="doc-row-main">' +
            '<span class="doc-row-title" style="display:block">'+doc.title+'</span>' +
            '<span class="doc-row-meta" style="display:block">'+doc.readTime+' · Updated '+doc.updated+'</span>' +
          '</span>' +
          '<button type="button" class="fav-btn'+(isFav?' on':'')+'" aria-label="Toggle favorite">♥</button>';
        row.addEventListener('click', function(){
          state.activeDoc = doc.id;
          setView('doc');
        });
        row.querySelector('.fav-btn').addEventListener('click', function(e){
          e.stopPropagation();
          state.favorites[doc.id] = !state.favorites[doc.id];
          renderDocRows();
        });
        els.docList.appendChild(row);
      });
    }

    els.favToggle.addEventListener('click', function(){
      var cat = catById(state.activeCategory);
      state.favOnlyByCat[cat.id] = !state.favOnlyByCat[cat.id];
      renderList();
    });
    els.searchInput.addEventListener('input', function(e){
      var cat = catById(state.activeCategory);
      state.searchByCat[cat.id] = e.target.value;
      renderDocRows();
    });

    function renderDoc(){
      var doc = docById(state.activeDoc) || DOCS[0];
      state.activeDoc = doc.id;
      var cat = catById(doc.category);
      var isFav = !!state.favorites[doc.id];
      els.docFavToggle.classList.toggle('on', isFav);
      els.docFavToggle.style.color = isFav ? '#c94438' : '';

      var sectionsHtml = doc.sections.map(function(sec){
        var itemsHtml = '';
        if (sec.items){
          itemsHtml = '<ul>' + sec.items.map(function(li){ return '<li>'+li+'</li>'; }).join('') + '</ul>';
        }
        return '<div class="doc-section"><h3 style="color:'+cat.accent+'">'+sec.heading+'</h3><p>'+sec.body+'</p>'+itemsHtml+'</div>';
      }).join('');

      els.docBody.innerHTML =
        '<div class="doc-eyebrow"><span class="cat-name" style="color:'+cat.accent+'">'+cat.label+'</span>' +
        '<span class="meta">· '+doc.readTime+' · Updated '+doc.updated+'</span></div>' +
        '<h2>'+doc.title+'</h2>' +
        '<div class="doc-media"><span class="mono">'+doc.imageLabel+'</span></div>' +
        '<div class="doc-intro">'+doc.intro+'</div>' +
        sectionsHtml +
        '<div class="doc-help">Need help? Visit our booth team.</div>';
    }

    els.docFavToggle.addEventListener('click', function(){
      state.favorites[state.activeDoc] = !state.favorites[state.activeDoc];
      renderDoc();
    });

    function renderProduct(){
      var product = productById(state.activeProduct) || PRODUCTS[0];
      state.activeProduct = product.id;

      var pdfRows = product.pdfs.map(function(pdf){
        return '<a class="pdf-row" href="#" onclick="return false">' +
          '<span class="pdf-icon">PDF</span>' +
          '<span class="pdf-row-main">' +
            '<span class="pdf-row-title" style="display:block">'+pdf.label+'</span>' +
            '<span class="pdf-row-meta" style="display:block">'+pdf.meta+'</span>' +
          '</span>' +
          '<span class="pdf-row-chevron">›</span>' +
        '</a>';
      }).join('');

      els.productBody.innerHTML =
        '<div class="doc-eyebrow"><span class="cat-name" style="color:var(--bp-accent)">Product</span></div>' +
        '<h2>'+product.name+'</h2>' +
        '<div class="product-hero-thumb"><span aria-hidden="true">🖼️</span></div>' +
        '<div class="doc-section"><h3>Documents</h3>' +
        '<div class="pdf-list">'+pdfRows+'</div></div>' +
        '<div class="doc-help">Need help? Visit our booth team.</div>';
    }

    els.navButtons.forEach(function(btn){
      btn.addEventListener('click', function(){ setView(btn.dataset.nav); });
    });

    setView('home');
  }

  document.addEventListener('DOMContentLoaded', function(){
    var root = document.querySelector('[data-wusa-qr-fair]');
    if (root) init(root);
  });
})();
